import styled from 'styled-components'

export const NoProducts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 550px;
  padding: 20px;
  opacity: 0.5;
  transition: all 0.3s;
  cursor: pointer;

  & img {
    height: 150px;
    margin-bottom: 20px;
  }

  & p {
    font-size: 20px;
    font-weight: bold;
    color: #666;
  }

  &:hover {
    opacity: 1;
  }

  @media (max-width: 768px) {
    height: 350px;
  }
`

export const Title = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    & {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
`

export const Filter = styled.div`
  margin: 10px 10px 0 0;
  min-width: 250px;
  width: auto;
  & h3 {
    font-weight: 600;
    margin: 16px 0 0 0;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
  & div {
    padding: 4px;
  }

  @media (max-width: 1024px) {
    & {
      width: 250px;
    }
  }

  @media (max-width: 768px) {
    & {
      display: none;
    }
  }
`
export const FilterCheckboxes = styled.div`
  min-height: 30px;
  max-height: 300px;
  height: max-content;
  overflow-y: scroll;
  scrollbar-color: var(--color-medium-grey);
  scrollbar-width: thin;
  & div {
    padding: 0;
  }
`

export const ProductsContainer = styled.div`
  width: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 15px;
  margin-top: 10px;

  @media (max-width: 768px) {
    & {
      justify-content: center;
    }
  }
`

export const WrapperCards = styled.div`
  min-width: 220px;
  width: auto;
  background-color: #fff;
  border-radius: 5px;
`

export const ContentPage = styled.div`
  display: flex;
`

export const FiltersSelected = styled.div`
  background-color: var(--color-white);
  border-radius: 5px;
  padding: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  & p {
    margin: 0;
  }

  & div label {
    padding: 10px;
  }
  & div select {
    padding: 5px;
  }
  & div select:focus {
    outline: none;
  }
`

export const FilterItems = styled.div`
  display: flex;
  margin-right: auto;
  gap: 4px;
`

export const FilterItem = styled.div`
  font-size: 12px;
  background-color: var(--color-medium-grey);
  color: var(--color-white);
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  & svg {
    font-size: 20px;
    cursor: pointer;
  }
`

export const SubCategoryList = styled.div`
  margin-left: 4px;
  display: flex;
  flex-direction: column;
  & div {
    width: 100%;
    padding: 6px 0px;
    font-size: 12px;
    cursor: pointer;
  }
`

export const InputCategory = styled.div`
  & div {
    display: flex;
    align-items: center;
    padding: 4px 0;
    font-size: 13px;
    font-weight: 700;

    & span {
      margin-left: 4px;
      cursor: pointer;
    }
  }
`

export const Checkbox = styled.input`
  margin-right: 8px;
`

export const ModalContent = styled.div`
  padding: 30px;
  min-width: 300px;
`

export const ButtonToMobileCategories = styled.button`
  position: relative;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: gray;
  color: var(--color-white);
  font-size: 15px;
  border: none;
  padding: 10px;
  border-radius: 5px;
  margin: 0 5px 0 0;
  cursor: pointer;
  width: auto;

  &:hover {
    filter: brightness(0.9);
  }

  @media (max-width: 769px) {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
  }
`
